import React from 'react';
import { Link } from 'react-router-dom';
import { 
  BuildingOfficeIcon, 
  UserGroupIcon, 
  DocumentTextIcon, 
  CogIcon 
} from '@heroicons/react/24/outline';

const Club = () => {
  const clubSections = [
    {
      title: "გუნდის ისტორია",
      description: "ჩვენი კლუბის ისტორია, მიღწევები და მნიშვნელოვანი მომენტები",
      icon: BuildingOfficeIcon,
      href: "/club/history",
      color: "bg-blue-500"
    },
    {
      title: "ადმინისტრაცია",
      description: "კლუბის ხელმძღვანელობა და ადმინისტრაციული სტრუქტურა",
      icon: UserGroupIcon,
      href: "/club/administration",
      color: "bg-green-500"
    },
    {
      title: "ფინანსური ანგარიშგება",
      description: "კლუბის ფინანსური მდგომარეობა და ანგარიშგებები",
      icon: DocumentTextIcon,
      href: "/club/financial",
      color: "bg-yellow-500"
    },
    {
      title: "სტრუქტურა",
      description: "კლუბის ორგანიზაციული სტრუქტურა და დეპარტამენტები",
      icon: CogIcon,
      href: "/club/structure",
      color: "bg-purple-500"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 font-georgian mb-4">
            კლუბი
          </h1>
          <p className="text-xl text-gray-600 font-georgian max-w-3xl mx-auto">
            FC ივერია - პროფესიონალური ფეხბურთის კლუბი, რომელიც მიზნად ისახავს 
            ქართული ფეხბურთის განვითარებას და ახალგაზრდა ფეხბურთელების აღზრდას.
          </p>
        </div>

        {/* Club Sections Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {clubSections.map((section) => (
            <Link
              key={section.title}
              to={section.href}
              className="group bg-white rounded-lg shadow-lg p-8 hover:shadow-xl transition-shadow duration-300"
            >
              <div className="flex items-start space-x-4">
                <div className={`${section.color} p-3 rounded-lg`}>
                  <section.icon className="h-8 w-8 text-white" />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-semibold text-gray-900 font-georgian mb-2 group-hover:text-primary-600 transition-colors">
                    {section.title}
                  </h3>
                  <p className="text-gray-600 font-georgian">
                    {section.description}
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Club Info */}
        <div className="mt-16 bg-white rounded-lg shadow-lg p-8">
          <h2 className="text-2xl font-bold text-gray-900 font-georgian mb-6">
            კლუბის შესახებ
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 font-georgian mb-4">
                ჩვენი მისია
              </h3>
              <p className="text-gray-600 font-georgian leading-relaxed">
                FC ივერია მიზნად ისახავს ქართული ფეხბურთის განვითარებას, 
                ახალგაზრდა ფეხბურთელების აღზრდას და პროფესიონალური ფეხბურთის 
                კულტურის ჩამოყალიბებას. ჩვენ ვცდილობთ, რომ ჩვენი გუნდი 
                იყოს საუკეთესო ქართულ ფეხბურთში.
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 font-georgian mb-4">
                ჩვენი ღირებულებები
              </h3>
              <ul className="space-y-2 text-gray-600 font-georgian">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-primary-600 rounded-full mr-3"></span>
                  პროფესიონალიზმი
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-primary-600 rounded-full mr-3"></span>
                  სპორტული სულისკვეთება
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-primary-600 rounded-full mr-3"></span>
                  გუნდური სულისკვეთება
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-primary-600 rounded-full mr-3"></span>
                  სამართლიანობა
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-primary-600 rounded-full mr-3"></span>
                  პატივისცემა
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Club;
